import { getActionCreators as baseGetActionCreators } from '@common/react/store/Item';
import { WithId } from '@common/typescript/objects/WithId';

import { User } from '@app/objects/User';
import { ApplicationState } from '@app/store/index';

export function getActionCreators<T extends WithId>() {
	return baseGetActionCreators<User, ApplicationState>();
}
